// Wrappers around the password-reset endpoints used by the public
// /password-reset/request and /password-reset/:token pages. Kept separate from
// api.ts because these are unauthenticated calls with their own response
// shapes.

import { AuthApiError } from "./api";
import { API_BASE_URL } from "./http";

async function parseError(res: Response): Promise<AuthApiError> {
  let code = `http_${res.status}`;
  let message: string | null = null;
  try {
    const body = (await res.json()) as {
      error?: unknown;
      message?: unknown;
    };
    if (typeof body.error === "string") code = body.error;
    if (typeof body.message === "string") message = body.message;
  } catch {
    // body wasn't JSON
  }
  return new AuthApiError(code, res.status, message);
}

export async function requestPasswordReset(input: {
  email: string;
}): Promise<void> {
  const res = await fetch(`${API_BASE_URL}/auth/password-reset/request`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      accept: "application/json",
    },
    body: JSON.stringify({ email: input.email }),
  });
  if (!res.ok) throw await parseError(res);
}

export interface PasswordResetLookup {
  email: string;
}

export async function lookupPasswordReset(
  token: string,
): Promise<PasswordResetLookup> {
  const res = await fetch(
    `${API_BASE_URL}/auth/password-reset/${encodeURIComponent(token)}`,
    {
      method: "GET",
      headers: { accept: "application/json" },
    },
  );
  if (!res.ok) throw await parseError(res);
  return (await res.json()) as PasswordResetLookup;
}

export async function confirmPasswordReset(input: {
  token: string;
  password: string;
}): Promise<void> {
  const res = await fetch(
    `${API_BASE_URL}/auth/password-reset/${encodeURIComponent(input.token)}/confirm`,
    {
      method: "POST",
      headers: {
        "content-type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({ password: input.password }),
    },
  );
  if (!res.ok) throw await parseError(res);
}
